import axios from 'axios';
import { getUrl } from '../service-utils';
import authHeader from '../auth-header';

const BASE = `${getUrl()}admin/errors`;

export type ErrorSeverity = 'low' | 'medium' | 'high' | 'critical';
export type ErrorCategory =
  | 'auth'
  | 'validation'
  | 'database'
  | 'external_api'
  | 'ingestion'
  | 'ai'
  | 'unknown';

export interface ErrorLogEntry {
  _id: string;
  message: string;
  severity: ErrorSeverity;
  category: ErrorCategory;
  count: number;
  lastOccurrence: string;
  acknowledgedAt?: string;
  acknowledgedBy?: string;
  context?: {
    endpoint?: string;
    stack?: string;
    [key: string]: unknown;
  };
}

export interface ErrorsPage {
  items: ErrorLogEntry[];
  total: number;
  page: number;
  pages: number;
  limit: number;
}

export interface ErrorsFilter {
  page?: number;
  severity?: ErrorSeverity;
  category?: ErrorCategory;
  acknowledged?: boolean;
  from?: string;
  to?: string;
}

export const adminErrorsService = {
  async list(filter: ErrorsFilter = {}): Promise<ErrorsPage> {
    const params: Record<string, string | number> = { page: filter.page ?? 1 };
    if (filter.severity) params.severity = filter.severity;
    if (filter.category) params.category = filter.category;
    if (filter.acknowledged !== undefined)
      params.acknowledged = String(filter.acknowledged);
    if (filter.from) params.from = filter.from;
    if (filter.to) params.to = filter.to;

    const { data } = await axios.get<{ status: string; data: ErrorsPage }>(
      BASE,
      { params, headers: authHeader() }
    );
    return data.data;
  },

  async acknowledge(id: string): Promise<ErrorLogEntry> {
    const { data } = await axios.post<{
      status: string;
      data: ErrorLogEntry;
    }>(`${BASE}/${id}/acknowledge`, {}, { headers: authHeader() });
    return data.data;
  }
};
